import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import filterWrapper from './filterTypes/filterWrapper';
import FilterMultiSelect from './filterTypes/FilterMultiSelect';
import FilterWithSearchMulti from './filterTypes/FilterWithSearchMulti';
import FilterWithClientSearchMulti from './filterTypes/FilterWithClientSearchMulti';
import FilterDateRange from './filterTypes/FilterDateRange';
import { toUI } from '../utility/mapStaticData';

import './Filter.css';
import { TYPE, FILTER_PARAM, ORDER_STATUS, RFQ_STATUS } from '../utility/types';

class FilterModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal,
    };
  }

  static get propTypes() {
    return {
      showModal: PropTypes.bool,
      setDisplayFilter: PropTypes.func,
      staticData: PropTypes.object,
      coords: PropTypes.object,
      onFilter: PropTypes.func,
      onFilterDateRange: PropTypes.func,
      recentlyUsed: PropTypes.object,
      onFetchClients: PropTypes.func,
      filterParams: PropTypes.object,
      type: PropTypes.oneOf([''].concat(TYPE.values)),
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ showModal: nextProps.showModal });
  }

  handleCloseModal() {
    this.props.setDisplayFilter(false);
  }

  stringToIdList(filterString) {
    if (!filterString) {
      return [];
    }
    const stringArray = filterString.split(',');
    const idArray = stringArray.map(val => parseInt(val, 10));

    return idArray;
  }

  stringToStringList(filterString) {
    if (!filterString) {
      return [];
    }
    const stringArray = filterString.split(',');

    return stringArray;
  }

  render() {
    const { staticData, coords, onFilter, onFilterDateRange,
      onFetchClients, filterParams, type,
      recentlyUsed } = this.props;
    const style = {
      overlay: {},
      content: {
        top: coords ? coords.top : 0,
        left: coords ? coords.left : 0
      }
    };
    const statusTypes = type === TYPE.ORDER ? ORDER_STATUS.values : RFQ_STATUS.values;
    const STATUS = type === TYPE.ORDER ? FILTER_PARAM.ORDER_STATUS : FILTER_PARAM.RFQ_STATUS;
    const dateFilterKey = `${FILTER_PARAM.START_DATE}-${FILTER_PARAM.END_DATE}`;

    const ClientFilter = filterWrapper(FilterWithClientSearchMulti, FILTER_PARAM.CLIENT);
    const InstrumentFilter = filterWrapper(FilterWithSearchMulti, FILTER_PARAM.INSTRUMENT);
    const SalespersonFilter = filterWrapper(FilterWithSearchMulti, FILTER_PARAM.SALES_PERSON);
    const StatusFilter = filterWrapper(FilterMultiSelect, STATUS);
    const DateFilter = filterWrapper(FilterDateRange, dateFilterKey);

    return (
      <div className="FilterModal">
        <ReactModal
          isOpen={this.state.showModal}
          style={style}
          overlayClassName="FilterModal-overlay"
          className="FilterModal-content"
          parentSelector={() => document.querySelector('.FilterModal')}
          onRequestClose={() => this.handleCloseModal()}
        >
          <ClientFilter
            mapFn={toUI.client}
            onFetchClients={onFetchClients}
            recentlyUsedKey="Client"
            recentlyUsed={recentlyUsed.Client}
            onFilter={onFilter}
            propertyName="OrbClientId"
            label="Client"
            filterValues={this.stringToIdList(filterParams[FILTER_PARAM.CLIENT])}
          />
          <InstrumentFilter
            possibleValues={staticData.instrumentTypes}
            mapFn={toUI.instrumentType}
            propertyName="InstrumentTypeId"
            onFilter={onFilter}
            label="Instrument"
            filterValues={this.stringToIdList(filterParams[FILTER_PARAM.INSTRUMENT])}
          />
          <SalespersonFilter
            possibleValues={staticData.salesPeople}
            mapFn={toUI.salesPerson}
            propertyName="Id"
            onFilter={onFilter}
            label="Sales Person"
            filterValues={this.stringToIdList(filterParams[FILTER_PARAM.SALES_PERSON])}
          />
          <StatusFilter
            possibleValues={statusTypes}
            mapFn={val => ({ label: val, value: val })}
            onFilter={onFilter}
            filterValues={this.stringToStringList(filterParams[STATUS])}
          />
          <DateFilter
            onFilterDateRange={onFilterDateRange}
            labelStart="Start Date"
            labelEnd="End Date"
            filterKeyStart={FILTER_PARAM.START_DATE}
            filterKeyEnd={FILTER_PARAM.END_DATE}
            filterValueStart={filterParams[FILTER_PARAM.START_DATE]}
            filterValueEnd={filterParams[FILTER_PARAM.END_DATE]}
          />
        </ReactModal>
      </div>
    );
  }
}

export default FilterModal;



// WEBPACK FOOTER //
// ./src/filter/FilterModal.js